export const ACTION = {
    GET_DISTRIBUTOR_CORRNER: 'GET_DISTRIBUTOR_CORRNER',
    GET_DISTRIBUTOR_CORRNER_FAQ: 'GET_DISTRIBUTOR_CORRNER_FAQ',
    GET_DISTRIBUTOR_CORRNER_ONBOARD_DIGITALLY: 'GET_DISTRIBUTOR_CORRNER_ONBOARD_DIGITALLY',
    GET_DISTRIBUTOR_CORRNER_ONBOARD_LOGIN: 'GET_DISTRIBUTOR_CORRNER_ONBOARD_LOGIN',
    DISTRIBUTOR_CORRNER_WHYBE:'DISTRIBUTOR_CORRNER_WHYBE',
    DISTRIBUTOR_CORRNER_GETSTARTED:'DISTRIBUTOR_CORRNER_GETSTARTED',
    DISTRIBUTOR_BECOME_DISTRIBUTOR:'DISTRIBUTOR_BECOME_DISTRIBUTOR',
    DISTRIBUTOR_CORRNER_FORM_DISCLOSURE: 'DISTRIBUTOR_CORRNER_FORM_DISCLOSURE',
    DISTRIBUTOR_CORRNER_SEBI: 'DISTRIBUTOR_CORRNER_SEBI',
    GET_HANDBOOK: 'GET_HANDBOOK',
    GET_HANDBOOK_DETAILS: 'GET_HANDBOOK_DETAILS',
};
